export default {
  title: 'ExpertOrder',
  form: {
    api_key: {
      label: 'Cheie API',
    },
  },
  buttons: {
    save: 'Salvați',
  },
  toasts: {
    error: 'Salvarea modificărilor a eșuat',
    success: 'Modificările au fost salvate',
  },
  connected: {
    title: 'ExpertOrder este conectat',
    description: 'Această integrare este configurată.',
  },
};
